export const helperConstants = {
    GET_COUNTRY_LIST: 'GET_COUNTRY_LIST',
    GET_STATE_LIST: 'GET_STATE_LIST',
    GET_CITY_LIST: 'GET_CITY_LIST'
};
